module.exports = __webpack_public_path__ + "static/media/hospitality.752ceb90.jpg";